/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { GetApiPublicTabletServices200, GetApiPublicTabletServices400, GetApiPublicTabletServices403, GetApiPublicTabletServices404, GetApiPublicTabletServices500, GetApiPublicTabletServicesQueryParams, GetApiPublicTabletServicesQueryResponse } from "../entities/GetApiPublicTabletServices";
import { modelsErrorResponseSchema } from "./models/errorResponseSchema";
import { modelsPublicServicesOutputSchema } from "./models/publicServicesOutputSchema";
import { z } from "zod/v4";

export const getApiPublicTabletServicesQueryParamsSchema = z.object({
    "branch_id": z.coerce.number().int().min(1).describe("ID филиала")
    }) as unknown as z.ZodType<GetApiPublicTabletServicesQueryParams>

/**
 * @description OK
 */
export const getApiPublicTabletServices200Schema = z.lazy(() => modelsPublicServicesOutputSchema) as unknown as z.ZodType<GetApiPublicTabletServices200>

/**
 * @description Некорректный branch_id
 */
export const getApiPublicTabletServices400Schema = z.lazy(() => modelsErrorResponseSchema).describe("Standard error response") as unknown as z.ZodType<GetApiPublicTabletServices400>

/**
 * @description Некорректный филиальный контекст
 */
export const getApiPublicTabletServices403Schema = z.lazy(() => modelsErrorResponseSchema).describe("Standard error response") as unknown as z.ZodType<GetApiPublicTabletServices403>

/**
 * @description Филиал или компания недоступны
 */
export const getApiPublicTabletServices404Schema = z.lazy(() => modelsErrorResponseSchema).describe("Standard error response") as unknown as z.ZodType<GetApiPublicTabletServices404>

/**
 * @description Ошибка определения филиала или загрузки услуг
 */
export const getApiPublicTabletServices500Schema = z.lazy(() => modelsErrorResponseSchema).describe("Standard error response") as unknown as z.ZodType<GetApiPublicTabletServices500>

export const getApiPublicTabletServicesQueryResponseSchema = z.lazy(() => getApiPublicTabletServices200Schema) as unknown as z.ZodType<GetApiPublicTabletServicesQueryResponse>